export default __webpack_public_path__ + "static/media/LOOC-B-BiodiversityShort 5-Instructional-Video004.9ff0ba7c.mp4";